'use client'

import { ReactElement, useActionState, useEffect, useState, useTransition } from "react";
import CommonTextInput from "./common/inputs/CommonTextInput";
import PhoneInput from "./common/inputs/PhoneInput";
import TaxCodeTextInput from "./common/inputs/TaxCodeTextInput";
import Button from "./common/Button";
import { sa_generateLead } from "@/app/actions/lead_gen/action";
import { useReCaptcha } from "next-recaptcha-v3";
import { performRecaptcha } from "@/utils/client/client_api";
import { ConfigurationForm } from "@/types/configuration";
import SelectInput from "./common/inputs/SelectInput";

interface Props {
    configuratioForm: ConfigurationForm
    csrfToken?: string
}

const FormLead: React.FC<Props> = (props: Props) => {

    const [state, setState] = useState<any>({});
    const [errorMessage, setErrorMessage] = useState<string>();

    const [isPending, startTransition] = useTransition();
    const [isLoading, setIsLoading] = useState(false);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [taxCode, setTaxCode] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [phoneCountryCode, setPhoneCountryCode] = useState("+39");

    const [privacyHabacus, setPrivacyHabacus] = useState(false);



    const [firstSelectedOption, setFirstSelectedOption] = useState<any>();
    const [secondSelectedOption, setSecondSelectedOption] = useState<any>();
    const [thirdSelectedOption, setThirdSelectedOption] = useState<any>();
    const [fourthSelectedOption, setFourthSelectedOption] = useState<any>();

    // const { executeRecaptcha } = useReCaptcha();

    const firstQuestion = "Come sei venuto/a a conoscenza del fondo convenzionato?"
    const firstQuestionOptions = [
        {
            label: 'Evento educativo di Bank Station e Fast Forward Foundation',
            value: 'Evento educativo di Bank Station e Fast Forward Foundation',
        },
        {
            label: 'Instagram',
            value: 'Instagram',
        },
        {
            label: 'TikTok',
            value: 'TikTok',
        },
        {
            label: 'Articolo su giornale o testata online',
            value: 'Articolo su giornale o testata online',
        },
        {
            label: 'Consiglio di un familiare',
            value: 'Consiglio di un familiare',
        },
        {
            label: 'Consiglio di un altro conoscente',
            value: 'Consiglio di un altro conoscente',
        },
        {
            label: 'Altro',
            value: 'Altro',
        }
    ]

    const secondQuestion = "Quando prendi decisioni economiche o finanziarie, quanto lo fai in autonomia"
    const secondQuestionOptions = [
        {
            label: 'Non prendo decisioni autonomamente, mi affido completamente a un familiare o ad altre persone',
            value: 'Non prendo decisioni autonomamente, mi affido completamente a un familiare o ad altre persone',
        },
        {
            label: 'Mi affido principalmente a un familiare o ad altre persone, anche se a volte partecipo alla decisione',
            value: 'Mi affido principalmente a un familiare o ad altre persone, anche se a volte partecipo alla decisione',
        },
        {
            label: 'Decido insieme a un familiare o a un’altra persona',
            value: 'Decido insieme a un familiare o a un’altra persona',
        },
        {
            label: 'Mi confronto con familiari o altre persone, ma prendo le decisioni principalmente in autonomia',
            value: 'Mi confronto con familiari o altre persone, ma prendo le decisioni principalmente in autonomia',
        },
        {
            label: 'Prendo decisioni completamente in autonomia dopo essermi opportunamente informato',
            value: 'Prendo decisioni completamente in autonomia dopo essermi opportunamente informato',
        }
    ]

    const thirdQuestion = "Quanto ha influito il fatto che non siano previste spese di gestione per gli studenti?"
    const thirdQuestionOptions = [
        {
            label: 'Non ha influito per nulla',
            value: 'Non ha influito per nulla',
        },
        {
            label: 'Ha influito poco',
            value: 'Ha influito poco',
        },
        {
            label: 'Ha influito abbastanza',
            value: 'Ha influito abbastanza',
        },
        {
            label: 'Ha influito molto',
            value: 'Ha influito molto',
        },
        {
            label: 'È stato determinante nella mia decisione',
            value: 'È stato determinante nella mia decisione',
        }
    ]

    const fourthQuestion = "Quanto ha influito l’esistenza del meccanismo di cofinanziamento?"
    const fourthQuestionOptions = [
        {
            label: 'Non ha influito per nulla',
            value: 'Non ha influito per nulla',
        },
        {
            label: 'Ha influito poco',
            value: 'Ha influito poco',
        },
        {
            label: 'Ha influito abbastanza',
            value: 'Ha influito abbastanza',
        },
        {
            label: 'Ha influito molto',
            value: 'Ha influito molto',
        },
        {
            label: 'È stato determinante nella mia decisione',
            value: 'È stato determinante nella mia decisione',
        }
    ]

    const handleSubmit = (formData: FormData) => {

        startTransition(async () => {
            try {
                debugger
                setIsLoading(true);

                // const recaptchaToken = await executeRecaptcha("lead_gen");
                // const res = await performRecaptcha(recaptchaToken)
                // if (!res.isOk) {
                //     throw "no recaptcha valid"
                // }

                const response = await sa_generateLead(undefined, formData);
                if (!response.success) {
                    throw response
                }
                setState({ success: true });
            } catch (err: any) {
                if (err.name === "ZodError") {
                    // Errore di validazione
                    setState(err);
                } else {
                    // Errore di login Firebase
                    setErrorMessage(err.message);
                }
            } finally {
                setIsLoading(false);
            }
        });
    };

    const renderLeadGeneratedElement = (): ReactElement => {
        return (
            <div className="pt-8 lg:mx-40 lg:pb-40">
                <div className='h-full lg:basis-full'>
                    <h1 className="mb-5 text-center">Ottimo!</h1>
                    <p className="text-center">A breve riceverai un messaggio con le informazioni per completare il processo di certificazione.</p>
                </div>
            </div>
        )
    }

    const renderForm = (): ReactElement => {
        return (
            <div className="pt-8 lg:mx-40">
                <div className='h-full lg:basis-full'>
                    <h1 className="mb-5 text-center">Compila il form</h1>
                    <div className='text-center mb-10'>
                        Compila il form per registrarti*
                    </div>
                    <form action={handleSubmit}>
                        <input type="hidden" name="csrfToken" value={props.csrfToken} />
                        <div className='mb-5 lg:mb-8'>
                            <CommonTextInput
                                name="firstName"
                                type='text'
                                labelText={'Nome'}
                                isMandatory={true}
                                minLength={2}
                                maxLength={30}
                                inputText={firstName}
                                setInputText={setFirstName}
                                isDisabled={isPending || isLoading}
                            />
                        </div>
                        {state.errors?.firstName && (
                            <p className="text-red-500 text-sm">{state.errors.firstName[0]}</p>
                        )}

                        <div className='mb-5 lg:mb-8'>
                            <CommonTextInput
                                name="lastName"
                                type='text'
                                labelText={'Cognome'}
                                isMandatory={true}
                                minLength={2}
                                maxLength={30}
                                inputText={lastName}
                                setInputText={setLastName}
                                isDisabled={isPending || isLoading}
                            />
                        </div>
                        {state.errors?.lastName && (
                            <p className="text-red-500 text-sm">{state.errors.lastName[0]}</p>
                        )}

                        <div className='mb-5 lg:mb-8'>
                            <PhoneInput
                                name="phone"
                                type='text'
                                labelText={'Telefono'}
                                isMandatory={true}
                                minLength={10}
                                maxLength={15}
                                inputText={phone}
                                setInputText={setPhone}
                                countryCode={phoneCountryCode} // Pass the current country code
                                setCountryCode={setPhoneCountryCode} // Pass the function to update the country code
                                isDisabled={isPending || isLoading}
                            />
                        </div>
                        {state.errors?.phoneCountryCode && (
                            <p className="text-red-500 text-sm">{state.errors.phoneCountryCode[0]}</p>
                        )}
                        {state.errors?.phone && (
                            <p className="text-red-500 text-sm">{state.errors.phone[0]}</p>
                        )}

                        <div className='mb-5 lg:mb-8'>
                            <CommonTextInput
                                name="email"
                                type='text'
                                labelText={'E-mail'}
                                isMandatory={true}
                                minLength={5}
                                maxLength={50}
                                inputText={email}
                                setInputText={setEmail}
                                isDisabled={isPending || isLoading}
                            />
                        </div>
                        {state.errors?.email && (
                            <p className="text-red-500 text-sm">{state.errors.email[0]}</p>
                        )}

                        <div className='mb-5 lg:mb-8'>
                            <TaxCodeTextInput
                                name="taxCode"
                                labelText={'Codice fiscale'}
                                isMandatory={true}
                                inputText={taxCode}
                                setInputText={setTaxCode}
                                isDisabled={isPending || isLoading}
                            />
                        </div>
                        {state.errors?.taxCode && (
                            <p className="text-red-500 text-sm">{state.errors.taxCode[0]}</p>
                        )}

                        <div className='mb-5 lg:mb-8'>
                            <SelectInput
                                name="referralSource"
                                loadingMessageText={"Caricamento..."}
                                noOptionsMessageText={"Nessun risultato"}
                                labelText={firstQuestion}
                                selectedOption={firstSelectedOption}
                                setSelectedOption={setFirstSelectedOption}
                                options={firstQuestionOptions}
                                isClearable={true}
                                isMandatory={true}
                                isDisabled={isPending || isLoading} />
                        </div>
                        {state.errors?.referralSource && (
                            <p className="text-red-500 text-sm">{state.errors.referralSource[0]}</p>
                        )}

                        <div className='mb-5 lg:mb-8'>
                            <SelectInput
                                name="economicDecisions"
                                loadingMessageText={"Caricamento..."}
                                noOptionsMessageText={"Nessun risultato"}
                                labelText={secondQuestion}
                                selectedOption={secondSelectedOption}
                                setSelectedOption={setSecondSelectedOption}
                                options={secondQuestionOptions}
                                isClearable={true}
                                isMandatory={true}
                                isDisabled={isPending || isLoading} />
                        </div>
                        {state.errors?.economicDecisions && (
                            <p className="text-red-500 text-sm">{state.errors.economicDecisions[0]}</p>
                        )}
                        <div className='mb-2 lg:mb-2 pl-1'>
                            <div className="text-xl">
                                Nell'intenzione ad iscriverti al fondo pensione:
                            </div>
                        </div>

                        <div className='mb-5 lg:mb-8'>
                            <SelectInput
                                name="economicAffectedDecisionsNoSpent"
                                loadingMessageText={"Caricamento..."}
                                noOptionsMessageText={"Nessun risultato"}
                                labelText={thirdQuestion}
                                selectedOption={thirdSelectedOption}
                                setSelectedOption={setThirdSelectedOption}
                                options={thirdQuestionOptions}
                                isClearable={true}
                                isMandatory={true}
                                isDisabled={isPending || isLoading} />
                        </div>
                        {state.errors?.economicDecisions && (
                            <p className="text-red-500 text-sm">{state.errors.economicAffectedDecisionsNoSpent[0]}</p>
                        )}

                        <div className='mb-5 lg:mb-8'>
                            <SelectInput
                                name="economicAffectedDecisionsCoFinancing"
                                loadingMessageText={"Caricamento..."}
                                noOptionsMessageText={"Nessun risultato"}
                                labelText={fourthQuestion}
                                selectedOption={fourthSelectedOption}
                                setSelectedOption={setFourthSelectedOption}
                                options={fourthQuestionOptions}
                                isClearable={true}
                                isMandatory={true}
                                isDisabled={isPending || isLoading} />
                        </div>
                        {state.errors?.economicDecisions && (
                            <p className="text-red-500 text-sm">{state.errors.economicAffectedDecisionsCoFinancing[0]}</p>
                        )}

                        <div className='flex items-center justify-center  lg:justify-normal'>
                            <div className='flex gap-2 items-center justify-center lg:justify-normal'>
                                <input type="checkbox" name="privacyHabacus" id="privacyHabacus" className='w-6 h-6' checked={privacyHabacus} onChange={() => { setPrivacyHabacus(!privacyHabacus) }} disabled={isPending || isLoading} />
                                <label htmlFor="privacyHabacus" className='smallerText italic '>Dichiaro di aver preso visione dell&apos;<a href="https://r.habacus.com/short/infoprivacy_uwelfare" target="_blank" rel="noopener noreferrer" className='underline'>Informativa sulla Privacy</a> e di accettarne i termini.</label>
                            </div>
                        </div>
                        {state.errors?.privacyHabacus && (
                            <p className="text-red-500 text-sm">{state.errors.privacyHabacus[0]}</p>
                        )}
                        <div className='text-center my-8'>
                            <Button
                                text="Invia"
                                type="submit"
                                disabled={false}
                                isLoading={isLoading}
                            />
                        </div>
                        <div className='mb-5 lg:mb-8 flex justify-center lg:justify-normal'>
                            <div className='smallerText w-10/12 text-center'>
                                *Per poter accedere a Uwelfare è necessario registrarsi prima tramite il form.
                            </div>
                        </div>
                    </form>
                </div>
                <div className='hidden lg:block lg:h-full lg:basis-full'>
                    {/* <Image src={desktopImageFORM} alt="Studentessa concentrata che lavora al computer in uno spazio di studio condiviso." className="  rounded-cornerDesk" /> */}
                </div>
            </div>
        );
    }

    return (
        <div className="px-5 lg:px-40 pb-20 lg:py-40 bg-grayLight rounded-t-cornerMob lg:rounded-t-[8rem]">
            {state?.success ? renderLeadGeneratedElement() : renderForm()}
        </div>
    );
}

export default FormLead;
